import {Button, Divider, Modal, Form, Input, notification} from "antd";
import {ChangeSpecificationsValidation, Validation} from "../utilis/tools/validation";
import React, {useContext, useState} from "react";
import {ConvertPersianToEnglish} from "../utilis/helpers/convertor";
import VerifiedUser from "../utilis/models/verifiedUser"
import {DatePicker, JalaliLocaleListener} from "antd-jalali";
import locale from "antd/es/date-picker/locale/fa_IR";
import Request from "../utilis/api/Request";
import Urls from "../utilis/api/Urls";
import AuthContext from "../utilis/contexts/AuthContext";
import {useSearchParams} from "react-router-dom";
type Props = {
    handleVerifiedUsers: Function,
    handleVerificationTry:Function,
    verifiedUsers:Array<VerifiedUser>,
    data?: any
    showAuthButton?:boolean
}

const UserVerification = ({handleVerifiedUsers,verifiedUsers,handleVerificationTry,showAuthButton=true, data}: Props) => {
    const authContext = useContext(AuthContext);
    const [form] = Form.useForm();
    const [searchParams,setSearchParams]=useSearchParams()
    const [nationalCode, setNationalCode] = useState<string>('');
    const [birthDate, setBirthDate] = useState<string>('');
    const [nationalCodeRequired, setNationalCodeRequired] = useState<boolean>(true);
    const [isOpen, setOpen] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isValidNationalCode, setValidNationalCode] = useState<boolean>(!!searchParams.get('isPortal')||false);
    const handleChangeNationalCode = (e: any) => {
        const nationalCode = e.target.value;
        setNationalCode(nationalCode);
        setNationalCodeRequired(true)
        if (nationalCode.length === 10 && ConvertPersianToEnglish(nationalCode)) {
            setValidNationalCode(true)
        } else {
            setValidNationalCode(false)
        }
    }
    const NationalCodeInquiry = (values: any) => {

        setLoading(true);

        const body = {
            isInquiry: true,
            FirstName: values.firstName,
            LastName: values.lastName,
            Cellphone: authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            BirthDate: birthDate.replaceAll('/', ''),
            NationalCode: ConvertPersianToEnglish(nationalCode)
        }

        Request(Urls.NationalCodeInquiry, body).then((response: any) => {
            handleVerificationTry(true)

            if (response.data.similar) {
                notification['success']({
                    message: 'موفق',
                    description: response.message,
                    duration: 60
                });
                const newUser: VerifiedUser = {
                    birthDate: birthDate,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    nationalCode: ConvertPersianToEnglish(nationalCode),
                }
                handleVerifiedUsers(newUser)
                setNationalCodeRequired(false)
                form.resetFields();

            } else {
                setNationalCodeRequired(true)
            }
        }).catch(() => {

        }).finally(() => {
            setLoading(false);
            setOpen(false)
        })


    }
    const handleChangeDatePicker = (value: any, persian: any) => {
        setBirthDate(persian)
    };
    const handleCancel = () => {
        setOpen(false);
        form.resetFields();
    };
    const handleOpenModal=()=>{
        if(verifiedUsers.length<6){
            setOpen(true)
        }else {
            notification['info']({
                message: 'حداکثر ۶ نفر می توانید به لیست افراد اضافه کنید. ',

                duration: 60
            });
        }
    }
    return <div className="flex justify-start items-center">

        <Form.Item
            label="کد ملی"
            name="nationalCode"

            rules={[Validation(ChangeSpecificationsValidation)]}
            className="  w-full ">
            <Input
                disabled={!showAuthButton}
                placeholder="کد ملی را وارد کنید"
                className="w-full"
                size="large" onChange={handleChangeNationalCode}
            />

        </Form.Item>
        {showAuthButton&&  <Button size="large" type="primary" disabled={!isValidNationalCode} className="mt-[5px]" onClick={handleOpenModal}>احراز هویت </Button>}

        <Modal title="احراز هویت با کد ملی" okText={'استعلام'} confirmLoading={isLoading}  open={isOpen} onOk={()=>{form.submit()}} onCancel={handleCancel}>
            <p>با احراز هویت نیاز به ارسال تصویر کارت ملی نمی باشد.</p>
            <Divider/>

              <Form

                name="verificationForm"
                className="w-full mt-4 flex flex-col"
                layout='vertical'
                onFinish={NationalCodeInquiry}
                form={form}
                autoComplete="off" scrollToFirstError={true}
            >


                <Form.Item
                    label="نام "
                    name="firstName"

                    initialValue={data.first_name ? data.first_name : ''}
                >
                    <Input size="large"/>
                </Form.Item>
                <Form.Item
                    label="  نام خانوادگی"
                    name="lastName"
                    initialValue={data.last_name ? data.last_name : ''}
                >
                    <Input size="large"/>
                </Form.Item>

                <Form.Item
                    label="تاریخ تولد"
                    name="birthDay"

                >
                    <JalaliLocaleListener/>
                    <DatePicker format="YYYY/MM/DD" onChange={handleChangeDatePicker} className="w-full" size="large"
                                nextIcon={<></>} locale={locale}/>

                </Form.Item>

            </Form>
        </Modal>
    </div>
}
export default UserVerification;